module.exports = __webpack_public_path__ + "static/pachnik-dba983fc59a421fa2c8f03ffbb1c2c4f.png";